module.exports = __webpack_public_path__ + "img/tech-chemistry.2f912114.jpeg";